// extracted by mini-css-extract-plugin
module.exports = {"makerGreen":"#385461","makerWhite":"white","button":"button_button__3_GL1"};